import { useEffect, useRef } from 'react'
import { useLocation, useNavigationType } from 'react-router'

// Submission flows render as a popup over the list behind them. Resetting scroll
// for those would yank the underlying page to the top while it is still visible
// through the scrim, and lose the reader's place when the popup closes.
const OVERLAY_ROUTES = [/^\/enquiries\/new\/?$/, /^\/cases\/new\/?$/, /^\/invoices\/new\//]

function isOverlay(pathname: string) {
  return OVERLAY_ROUTES.some((pattern) => pattern.test(pathname))
}

// A new page should start at the top. Back and forward keep their position so
// browser history still behaves the way people expect.
export function ScrollToTop() {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()
  const previous = useRef(pathname)

  useEffect(() => {
    const from = previous.current
    previous.current = pathname

    if (from === pathname) return
    if (navigationType === 'POP') return
    if (isOverlay(pathname) || isOverlay(from)) return

    window.scrollTo(0, 0)
  }, [pathname, navigationType])

  return null
}
